import call from '../assets/call.png';
import customWeatherLogo from '../assets/customweather_logo_wide.png';
import direct from '../assets/direct.png';
import email from '../assets/email.png';
import rescAlertLogo from '../assets/rescalert_small.png';
import seamless from '../assets/seamless.png';
import secure from '../assets/secure.png';
import unlimited from '../assets/unlimited.png';

export const aboutContent = {
  company: {
    title: 'About RescAlert',
    subtitle: 'What makes us different from others!',
    logo: rescAlertLogo,
    description:
      "Our platform doesn't replace your existing system, it makes it better! Each organization continues to use their day-to-day platforms they know and trust. When it's time for the organization to respond to an emergency, RescAlert's Fusion+ connects them together in real-time",
  },
  platform: {
    title: 'About Fusion+',
    description:
      'Overwatch Fusion+ is an advanced platform that unifies devices and systems into a cohesive interface, leveraging AI to enhance emergency management. It integrates data from sensors, cameras, communication devices, and monitoring systems, providing real-time insights and predictive analytics. By consolidating this information, Overwatch Fusion+ improves decision-making and response efficiency, eliminating the need to switch between systems and ensuring streamlined emergency management.',
    href: 'https://www.rescalert.com/our-company/about-us.html',
    linkLabel: 'Learn more',
  },
  contactTitle: 'Contact Us Now',
  weatherProvider: {
    name: 'CustomWeather',
    logo: customWeatherLogo,
    description: 'Weather Data provided by Custom Weather.',
    href: 'https://www.customweather.com/',
  },
};

export const aboutFeatures = [
  {
    icon: secure,
    title: 'Secure API',
    text: 'Our Open API allows for essentially unlimited integrations.',
  },
  {
    icon: unlimited,
    title: 'Unlimited Resources',
    text: 'Fusion+ is designed to integrate with any database and perform two-way synchronization.',
  },
  {
    icon: seamless,
    title: 'Seamless Integration',
    text: "Integrates with each organization's existing day-to-day system.",
  },
  {
    icon: direct,
    title: 'Direct Communication',
    text: 'Send alerts and messages to the people in your area and those just passing through.',
  },
];

export const aboutContacts = [
  {
    title: 'Call Us',
    icon: call,
    href: 'tel:+18508609824',
    label: '+1.850.860.9824',
  },
  {
    title: 'Email Us',
    icon: email,
    href: 'mailto:sales.info@rescalert.com',
    label: 'sales.info@rescalert.com',
  },
];
